import api from "./common";
import axios from "axios";
import { ApiResponse } from "@/types/api.types";
import {
  onReqFulfilled,
  onReqRejected,
  onResFulfilled,
  onResRejected,
} from "./helpers";
import { Teacher } from "@/types/user.types";
import { Tenant } from "@/types/tenants.types";

const adminAPI = axios.create({
  baseURL: process.env.REACT_APP_OLD_API_BASEURL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

adminAPI.interceptors.request.use(onReqFulfilled, onReqRejected);
adminAPI.interceptors.response.use(onResFulfilled, onResRejected);

// Teachers
export const addSingleTeacher = async (data) => api.post("/", { action: "register_staff", ...data });

export const addBulkTeachers = async (data): Promise<ApiResponse> => api.post("/", { action: "bulk_register_staff", ...data });

export const getTeachers = async (): Promise<ApiResponse<Teacher[]>> => api.get("/", { params: { action: "list_school_staff" } });

export const getTeachersCount = async (params: Record<string, any>) =>
  api.get("/", { params: { ...params, action: "list_school_staff_count" } });

export const getStudentsCount = async (params: Record<string, any>) =>
  api.get("/", { params: { ...params, action: "list_school_students_count" } });

export const editTeacher = async (data) => api.post(`/`, { action: "update_staff", ...data });

export const disableTeacherAccount = async (id: string): Promise<ApiResponse<null>> => api.patch(`/users/teachers/${id}/disable`);

export const enableTeacherAccount = async (id: string): Promise<ApiResponse<null>> => api.patch(`/users/teachers/${id}/enable`);

export const allocateSubjectToTeacher = async (data) => adminAPI.post("/", { action: "register_class_teacher_subject", ...data });

export const deleteSubjectAllocation = async (data): Promise<ApiResponse<null>> => adminAPI.post("/", { action: "delete_teacher_subjects", ...data });

export const updateAutoApprovalStatus = (data): Promise<ApiResponse<Tenant>> => adminAPI.post("/", { action: "update_course_approver", ...data })

export const updateSchoolDetails = (data): Promise<ApiResponse<Tenant>> => adminAPI.post("/", { action: "update_school", ...data })
